import { ChangeDetectorRef, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
//import { RutValidator } from 'ng9-rut';
//import { RutValidator } from 'ng2-rut';
import { ObservableInspService } from 'src/app/services/observable_insp';
import { UserService } from 'src/app/services/user.service';
import { RegistroComponent } from '../../../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
var SolicitanteInspComponent = /** @class */ (function () {
    // private rutValidator: RutValidator,
    function SolicitanteInspComponent(dialog, _formBuilder, _userService, _changeDetector, observableService, spinner, _router) {
        this.dialog = dialog;
        this._formBuilder = _formBuilder;
        this._userService = _userService;
        this._changeDetector = _changeDetector;
        this.observableService = observableService;
        this.spinner = spinner;
        this._router = _router;
        this.modificando = false;
        this.primerPaso = false;
        this.rut_encontrado = false;
        this.continuar = false;
        this.emailValido = false;
        this.celularValido = false;
        this.primerPaso_mod = false;
        this.btnBuscaRut = false;
        this.entrevalidar = false;
        this.firstFormGroup = this._formBuilder.group({
            rut: ["", [Validators.required]],
            dv: ["", [Validators.required]],
            mod_solicitante: this._formBuilder.group({
                nombre: ["", [Validators.required]],
                apellido_p: [""],
                apellido_m: [""],
                calle: ["", [Validators.required]],
                num: ["", [Validators.required]],
                complemento: [""],
                telefono: [""],
                cel: ["", [Validators.required]],
                ciudad: [""],
                comuna: [""],
                email: ["", [Validators.required, Validators.email]],
            }),
        });
        if (sessionStorage.getItem('identity-domCloud')) {
            var identityData = this._userService.getIdentity();
            this.firstFormGroup.controls['rut'].setValue(identityData.rut);
            this.firstFormGroup.controls['dv'].setValue(identityData.dv);
            this.validaRut();
            this.searchUser();
        }
        else {
            this._router.navigate(['/inicio']);
            swal({
                type: 'warning',
                text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            });
        }
    }
    SolicitanteInspComponent.prototype.ngOnInit = function () {
    };
    SolicitanteInspComponent.prototype.parametros = function (va) {
        //console.log('valo ', va);
        this.firstFormGroup.valid;
    };
    SolicitanteInspComponent.prototype.validaRut = function () {
        var rutSinPuntos = this.firstFormGroup.controls.rut.value + "-" + this.firstFormGroup.controls.dv.value;
        var resultado = comprueba(rutSinPuntos);
        /* this.firstFormGroup = this._formBuilder.group({
          rutFull: [rutSinPuntos, [this.rutValidator]]
        });
        */
        function comprueba(rutCompleto) {
            if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto))
                return false;
            var tmp = rutCompleto.split('-');
            var digv = tmp[1];
            var rut = tmp[0];
            if (digv == 'K')
                digv = 'k';
            return (digitoverificador(rut) == digv);
        }
        function digitoverificador(T) {
            var M = 0, S = 1;
            for (; T; T = Math.floor(T / 10))
                S = (S + T % 10 * (9 - M++ % 6)) % 11;
            return S ? S - 1 : 'k';
        }
        //console.log('va  vAva  ', resultado);
        if (resultado == true) {
            this.firstFormGroup.valid;
            this.btnBuscaRut = true;
        }
        else {
            this.btnBuscaRut = false;
        }
        //this.firstFormGroup.valid;
        this.entrevalidar = true;
        console.log("entre en validar ", this.entrevalidar);
    };
    SolicitanteInspComponent.prototype.buscar_info_sol = function () {
        var _this = this;
        var rutSinPuntos = this.firstFormGroup.controls.rut.value + "-" + this.firstFormGroup.controls.dv.value;
        if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
            rutSinPuntos = this.firstFormGroup.controls.rut.value
                .toString()
                .replace(".", "");
            if (rutSinPuntos.includes(".")) {
                rutSinPuntos = rutSinPuntos.replace(".", "");
            }
            //console.log("entre en el if de los puntos", rutSinPuntos);
        }
        console.log("rutSinPuntos", rutSinPuntos);
        this.continuar = false;
        this._userService.traerInfo_rut(rutSinPuntos).subscribe(function (response) {
            _this.firstFormGroup = _this._formBuilder.group({
                rut: ["", [Validators.required]],
                dv: ["", [Validators.required]],
                mod_solicitante: _this._formBuilder.group({
                    nombre: ["", [Validators.required]],
                    apellido_p: [""],
                    apellido_m: [""],
                    calle: ["", [Validators.required]],
                    num: ["", [Validators.required]],
                    complemento: [""],
                    telefono: [""],
                    cel: ["", [Validators.required]],
                    ciudad: [""],
                    comuna: [""],
                    email: ["", [Validators.required, Validators.email]],
                }),
            });
            console.log("avu: ", response);
            _this.rut_encontrado = false;
            if (response.status == true) {
                _this.info_rut = response.data;
                _this.rutSolicitante = _this.info_rut.rut;
                var fullRut = _this.rutSolicitante.split("-");
                //console.log("emit this.rutSolicitante", this.rutSolicitante)
                _this.observableService.usuario$.emit(_this.rutSolicitante);
                _this.firstFormGroup = _this._formBuilder.group({
                    rut: [fullRut[0], [Validators.required]],
                    dv: [fullRut[1], [Validators.required]],
                    mod_solicitante: _this._formBuilder.group({
                        nombre: [_this.info_rut.nombre, [Validators.required]],
                        apellido_p: [_this.info_rut.apellido_p],
                        apellido_m: [_this.info_rut.apellido_m],
                        calle: [_this.info_rut.calle, [Validators.required]],
                        num: [_this.info_rut.numero, [Validators.required]],
                        complemento: [_this.info_rut.complemento],
                        telefono: [_this.info_rut.telefono],
                        cel: [_this.info_rut.celular, [Validators.required]],
                        ciudad: ["SI"],
                        comuna: [_this.info_rut.comuna],
                        email: [_this.info_rut.email, [Validators.required, Validators.email]],
                    }),
                });
                _this.emailValido = _this.info_rut.emailValido;
                //console.log(this.info_rut, 'dataRut');
                _this.observableService.correo$.emit(_this.info_rut.email);
                //console.log(this.info_rut.email == "");
                //console.log(this.info_rut.email.length > 0);
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(String(_this.info_rut.email).toLowerCase())) {
                    _this.continuar = true;
                }
                _this.primerPaso = true;
                _this.rut_encontrado = true;
                _this._changeDetector.detectChanges();
            }
            if (response.status == false) {
                _this.modificando = true;
                _this.rut_encontrado = false;
                alert(response.message);
                _this.firstFormGroup = _this._formBuilder.group({
                    rut: ["", [Validators.required]],
                    dv: ["", [Validators.required]],
                    mod_solicitante: _this._formBuilder.group({
                        nombre: ["", [Validators.required]],
                        apellido_p: [""],
                        apellido_m: [""],
                        calle: ["", [Validators.required]],
                        num: ["", [Validators.required]],
                        complemento: [""],
                        telefono: [""],
                        cel: ["", [Validators.required]],
                        ciudad: [""],
                        comuna: [""],
                        email: ["", [Validators.required, Validators.email]],
                    }),
                });
            }
        }, function (error) {
            console.log(error);
            _this.modificando = true;
            _this.rut_encontrado = false;
            /* swal({
                type: 'error',
                title: 'Ha ocurrido un error!',
                text: error._body,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(() => {
            }, (dismiss) => {
                if (dismiss === 'timer') {
                }
            }); */
        });
    };
    SolicitanteInspComponent.prototype.mod_inforut = function () {
        this.firstFormGroup.controls.mod_solicitante.setValue({
            nombre: this.info_rut.nombre ? this.info_rut.nombre : "",
            apellido_p: this.info_rut.apellido_p ? this.info_rut.apellido_p : " ",
            apellido_m: this.info_rut.apellido_m ? this.info_rut.apellido_m : " ",
            calle: this.info_rut.calle ? this.info_rut.calle : "",
            num: this.info_rut.numero ? this.info_rut.numero : " ",
            complemento: this.info_rut.complemento ? this.info_rut.complemento : " ",
            telefono: this.info_rut.telefono ? this.info_rut.telefono : " ",
            cel: this.info_rut.celular ? this.info_rut.celular : "",
            ciudad: this.info_rut.ciudad ? this.info_rut.ciudad : " ",
            comuna: this.info_rut.comuna ? this.info_rut.comuna : " ",
            email: this.info_rut.email ? this.info_rut.email : " ",
        });
        if (this.firstFormGroup.controls.mod_solicitante.value.nombre === '' || this.firstFormGroup.controls.mod_solicitante.value.cel === '' || this.firstFormGroup.controls.mod_solicitante.value.calle === '') {
            this.sig = false;
        }
        this.primerPaso_mod = true;
        this.primerPaso = false;
        this.modificando = true;
    };
    SolicitanteInspComponent.prototype.guarda_mod = function () {
        var _this = this;
        //console.log('form group', this.firstFormGroup);
        if (this.firstFormGroup.controls.mod_solicitante.value.nombre === '' || this.firstFormGroup.controls.mod_solicitante.value.cel === '' || this.firstFormGroup.controls.mod_solicitante.value.calle === '') {
            this.sig = false;
        }
        else {
            this.sig = true;
        }
        this._userService
            .save_info_mod_solicitante(this.info_rut.rut, this.firstFormGroup.controls.mod_solicitante.value)
            .subscribe(function (response) {
            //console.log(response);
            _this.modificando = false;
            swal({
                type: "success",
                title: "Guardado!",
                text: response.message,
                confirmButtonColor: "#3F51B5",
                confirmButtonText: "Aceptar",
                timer: 3500,
            }).then(function () { }, function (dismiss) {
                if (dismiss === "timer") {
                }
            });
        }, function (error) {
            console.log(error);
            swal({
                type: "error",
                title: "Ha ocurrido un error!",
                text: error._body,
                confirmButtonColor: "#3F51B5",
                confirmButtonText: "Aceptar",
                timer: 3500,
            }).then(function () { }, function (dismiss) {
                if (dismiss === "timer") {
                }
            });
        });
    };
    SolicitanteInspComponent.prototype.cancelar_mod = function () {
        if (this.rut_encontrado) {
            this.modificando = false;
            this.primerPaso_mod = false;
            this.primerPaso = true;
        }
        else {
            this.modificando = false;
            this.rut_encontrado = false;
            this.primerPaso = false;
            this.primerPaso_mod = false;
        }
    };
    SolicitanteInspComponent.prototype.registro_sol = function () {
        var _this = this;
        var rutSinPuntos = this.firstFormGroup.controls.rut.value;
        if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
            rutSinPuntos = this.firstFormGroup.controls.rut.value
                .toString()
                .replace(".", "");
            if (rutSinPuntos.includes(".")) {
                rutSinPuntos = rutSinPuntos.replace(".", "");
            }
            //console.log("entre en el if de los puntos", rutSinPuntos);
        }
        this.rutSolicitante = this.info_rut.rut;
        var fullRut = this.rutSolicitante.split("-");
        var userinfo = {
            rut: fullRut[0],
            dv: fullRut[1],
            nombre: this.firstFormGroup.controls.mod_solicitante.value.nombre,
            app: this.firstFormGroup.controls.mod_solicitante.value.apellido_p,
            apm: this.firstFormGroup.controls.mod_solicitante.value.apellido_m,
            dir: this.firstFormGroup.controls.mod_solicitante.value.calle,
            num: this.firstFormGroup.controls.mod_solicitante.value.num,
            dircom: this.firstFormGroup.controls.mod_solicitante.value.complemento,
            telefono: this.firstFormGroup.controls.mod_solicitante.value.telefono,
            celular: this.firstFormGroup.controls.mod_solicitante.value.cel,
            ciudad: this.firstFormGroup.controls.mod_solicitante.value.ciudad,
            comuna: this.firstFormGroup.controls.mod_solicitante.value.comuna,
            email: this.firstFormGroup.controls.mod_solicitante.value.email,
        };
        this.firstFormGroup.controls.mod_solicitante.value.cel != ""
            ? (this.celularValido = true)
            : (this.celularValido = false);
        //console.log(this.celularValido);
        //console.log(userinfo);
        this._userService.save_solicitante(userinfo).subscribe(function (response) {
            //console.log(response);
            swal({
                type: "success",
                title: "Registrado!",
                text: response.message,
                confirmButtonColor: "#3F51B5",
                confirmButtonText: "Aceptar",
                timer: 3500,
            }).then(function () { }, function (dismiss) {
                if (dismiss === "timer") {
                }
            });
            _this.buscar_info_sol();
            _this.modificando = false;
        }, function (error) {
            console.log(error);
            swal({
                type: "error",
                title: "Ha ocurrido un error!",
                text: error._body,
                confirmButtonColor: "#3F51B5",
                confirmButtonText: "Aceptar",
                timer: 3500,
            }).then(function () { }, function (dismiss) {
                if (dismiss === "timer") {
                }
            });
        });
    };
    SolicitanteInspComponent.prototype.searchUser = function () {
        var _this = this;
        /* Buscar si existe en fm */
        var identityData = this._userService.getIdentity();
        var rut = identityData.rut + identityData.dv;
        this._userService.buscarUsuario(rutClean(rut)).subscribe(function (response) {
            if (response.message) {
                _this.spinner.hide();
                console.log(response);
            }
            if (response.register) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
            if (response.update) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    return SolicitanteInspComponent;
}());
export { SolicitanteInspComponent };
